import React from 'react';
import { Value } from 'slate'

import { cx, css } from 'helpers';
import {
  RENDER_MODE as RM,
} from 'shared/constants/slate';
import {
  EXPORT_PREVIEW_SIZE_REF,
  EXPORT_PREVIEW_ROOT_ID,
} from 'shared/constants/web';
import { BASE_COLOR } from 'shared/constants/colors';
import {
  MediumRareEditor,
  validations,
  nodes,
} from 'components/slate';

const { renderDefaultNode } = nodes;
const { validatePreview } = validations;


const validatePreviewPlugin = {validateNode: validatePreview};

const lastPlugins = [
  validatePreviewPlugin,
]


// In pixel.
const INNER_PA = 16;
const INNER_MV = 18;
const INNER_MH = 18;


const MadeWithMoagraph = () => (
  <span
    className={cx(
      "absolute dib bottom-0 right-0 pr1",
      "moa-ff-sans fw3",
    )}
    style={{
      color: BASE_COLOR.moonLightGray,
      fontSize: '11px',
      lineHeight: `${INNER_MV}px`,
      marginRight: `${INNER_MH}px`,
    }}
  >
    via Moagraph.com
  </span>
);



class BlogExportPreview extends React.Component {

  constructor(props) {
    super(props);

    const { document: doc } = props.value;

    this.state = {
      hasContentTopAligned: (doc.nodes.size > 1),
    };
  }

  componentDidUpdate() {
    const outerHeight = this.outer.clientHeight;
    const previewContent = this.inner.firstChild;
    const contentHeight = (previewContent
      ? previewContent.clientHeight
      : 0
    );

    const shouldTopAlignContent = (
      outerHeight
      - INNER_MV*2
      - INNER_PA*2
      - contentHeight
    ) / EXPORT_PREVIEW_SIZE_REF < 0.15;

    const { hasContentTopAligned } = this.state;
    if (shouldTopAlignContent && !hasContentTopAligned) {
      return this.setState({ hasContentTopAligned: true });
    }

    if (!shouldTopAlignContent && hasContentTopAligned) {
      return this.setState({ hasContentTopAligned: false });
    }
  }

  renderNode = (props) => {
    props = { ...props, renderMode: RM.RENDER_FOR_PREVIEW };
    return renderDefaultNode(props);
  }

  render() {
    const {
      rootId = EXPORT_PREVIEW_ROOT_ID,
      innerStyle = {},
      innerClass,
      value,
      withBottomFade = true,
      withBranding = true,
    } = this.props;

    // As separate instance of Value, so that we can apply
    // different validation rules (via lastPlugins) without
    // affecting the main instance.
    const previewValue = Value.fromJSON({ document: value.document });

    // Render content in 1:1 ratio container. Reference size
    // is meant to be 100% size where styling can be done against.
    return (
      <div
        id={rootId}
        style={{
          width: `${EXPORT_PREVIEW_SIZE_REF}px`,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        {/*
          all three outer classes
          + aspect-ratios--object needed for 1:1
        */}
        <div
          ref={ref => this.outer = ref}
          className="w-100 relative aspect-ratio--1x1"
        >
          <div
            className="aspect-ratio--object"
            style={{
              background: `linear-gradient(125deg, ${BASE_COLOR.nearWhite} 0%, ${BASE_COLOR.white})`,
            }}
          >
            <div
              ref={ref => this.inner = ref}
              className={cx(
                "overflow-hidden flex flex-column",
                innerClass,
                {'justify-start': this.state.hasContentTopAligned},
                {'justify-center': !this.state.hasContentTopAligned},
                {[bottomFadeClass]: withBottomFade},
              )}
              style={{
                background: BASE_COLOR.white,
                padding: `${INNER_PA}px`,
                margin: `${INNER_MV}px ${INNER_MH}px`,
                height: `calc(100% - ${INNER_MV}px*2)`,
                ...innerStyle,
              }}
            >
              {/* Wrapped in div to calculate the height together */}
              <div>
                <div>
                  {/* Maybe profile pic plus timestamp here */}
                </div>

                <MediumRareEditor
                  readOnly={true}
                  value={previewValue}
                  renderNode={this.renderNode}
                  lastPlugins={lastPlugins}
                />
              </div>
            </div>

            {withBranding && <MadeWithMoagraph />}
          </div>
        </div>
      </div>
    );
  }
}

const bottomFadeClass = css({
  position: 'relative',
  '&:before': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    // https://stackoverflow.com/a/30674347/3479934
    background: 'linear-gradient(to bottom, rgba(255,255,255,0) 90%, rgba(255,255,255,1))',
    zIndex: 1, // otherwise not showing up..
  },
})


export default BlogExportPreview;



// WEBPACK FOOTER //
// ./src/components/modules/blog/BlogExportPreview.js